/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-04-17 10:00:00
 *
 *******************************************************/
// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, TextContainer } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
// import UpgradeSuccessBanner from 'src/assets/images/account-settings/upgrade-turbo-success.png';
import { URL } from 'src/constants/links';

type Props = {
  active: boolean,
  removing: boolean,
  handleCancel: () => void,
  handleConfirm: () => void
};

type ComposedProps = Props & WithI18nProps;

class UpgradeSuccessModal extends Component<ComposedProps> {
  state = {
    checkedDontShowAgain: false
  };

  onLearnMore = () => {
    window.open(URL['NewVersionTurbo'], '_blank');
  };

  render() {
    const { active, handleCancel, i18n, gotoShopifyIntegration } = this.props;

    return (
      <Modal
        open={active}
        onClose={handleCancel}
        title={i18n.translate('AdminHTML.AppPreferences.UpgradeModal.successTitle')}
        primaryAction={{
          content: i18n.translate('AdminHTML.AppPreferences.UpgradeModal.successBtn'),
          onAction: gotoShopifyIntegration
        }}
        secondaryActions={{
          // content: i18n.translate('AdminHTML.Common.Action.close'),
          // onAction: handleCancel
          content: i18n.translate('AdminHTML.Common.Action.learnMore'),
          onAction: this.onLearnMore
        }}>
        <Modal.Section>
          <TextContainer>
            <p>
              {i18n.translate('AdminHTML.AppPreferences.UpgradeModal.successLabel1', {
                b: <b>{i18n.translate('AdminHTML.AppPreferences.UpgradeModal.successLabel1_b')}</b>
              })}
            </p>
            <p>
              {i18n.translate('AdminHTML.AppPreferences.UpgradeModal.successLabel2', {
                b: <b>{i18n.translate('AdminHTML.AppPreferences.UpgradeModal.successLabel2_b')}</b>
              })}
            </p>
          </TextContainer>
          {/* <img
            style={{ marginTop: '15px' }}
            src={UpgradeSuccessBanner}
            alt="banner-succss"
            className="video-upgrade"
            width={580}
            height={230}
          /> */}
          <iframe
            className="video-upgraded"
            style={{ marginTop: '15px' }}
            width="100%"
            height="315"
            src={URL['AppVersion_Upgrade_Success']}
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen></iframe>
        </Modal.Section>
      </Modal>
    );
  }
}

export default withI18n()(connect(null, null)(UpgradeSuccessModal));
